import { render, staticRenderFns } from "./IssueEnhanceProcesses.vue?vue&type=template&id=33534856&scoped=true&"
import script from "./IssueEnhanceProcesses.vue?vue&type=script&lang=js&"
export * from "./IssueEnhanceProcesses.vue?vue&type=script&lang=js&"
import style0 from "./IssueEnhanceProcesses.vue?vue&type=style&index=0&id=33534856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33534856",
  null
  
)

export default component.exports